import { Form, Input } from "antd";
import "./verificationCodeInput.css";

const VERIFICATION_CODE_LENGTH = 4;

const VerificationCodeInput = () => {
    const handleChange = (e) => {
        const { value, id } = e.target;
        const [fieldName, fieldIndex] = id.split("-");

        let fieldIntIndex = parseInt(fieldIndex, 10);
        if (value.length === 1) {
            const nextfield = document.querySelector(
                `input[id=nro-${fieldIntIndex + 1}]`
            );
            if (nextfield !== null) {
                nextfield.focus();
            }
        }
    };
    return (
        <div className='inputCode-container'>
            {[...Array(VERIFICATION_CODE_LENGTH)].map((_, index) => (
                <Form.Item key={index} name={`nro${index}`}>
                    <Input
                        id={`nro-${index}`}
                        className='inputCode-item'
                        size='large'
                        maxLength={1}
                        onChange={handleChange}
                    ></Input>
                </Form.Item>
            ))}
        </div>
    );
};

export default VerificationCodeInput;
